
import Cxc from "@/views/CxC/Cxc.vue";
import PaymentsReceived from "@/views/CxC/Payments.vue";
import ViewPayments from "@/views/CxC/ViewPayments.vue"
import DirectPayment from "@/views/CxC/DirectPayment.vue"
import ViewDirectPayment from "@/views/CxC/ViewDirectPayment.vue";
const cxcRoute=    {
    path: "/cxc",
    name: "cxc",
    component: Cxc,
    meta: {
      libre: true
    },
    children: [
      {
        path: "payments_cxc",
        name: "PaymentsReceived",
        component: PaymentsReceived,
        meta: {
          code: "CXC-02" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "view_payments/:id?",
        name: "ViewPaymentsCxC",
        component: ViewPayments,
        meta: {
          code: "CXC-02" // PAGOS / VER ViewPaymentsCxC (coincide con su lista); antes CXC-03 (vista pago directo)
        },
     
      },
      {
        path: "view_pre_payment_cxc/:id?",
 
        name: "ViewDirectPayment",
        component: ViewDirectPayment,
        meta: {
          code: "CXC-03" // Cambiado de IVENTORY: true a un código específico
        },
      },
      {
        path: "direct_payment",
      
        name: "DirectPayment",
        component: DirectPayment,
        meta: {
          code: "CXC-04" // Cambiado de IVENTORY: true a un código específico
        },
      },
    ],
  }


export default cxcRoute
